import { useEffect, useRef, useState } from "react";
import { Users, ChevronDown, ChevronUp } from "lucide-react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import UserAvatar from "@/components/ui/UserAvatar";

/** Point 3 (2026-09) — 3ᵉ segment « Utilisateur » de la bascule Perso/Globale (Admin & Premier Admin). */
export default function UserSegment({ value, onChange, module, testid }) {
  const { user } = useAuth();
  const isAdmin = user?.role === "admin" || !!user?.is_first_admin;
  const [open, setOpen] = useState(false);
  const [data, setData] = useState(null);
  const ref = useRef(null);
  const selectedId = typeof value === "string" && value.startsWith("user:") ? value.slice(5) : null;
  useEffect(() => {
    if (!open) return;
    api.get("/users/view-counts", { params: { module: module || "documents" } }).then(({ data }) => setData(data)).catch(() => setData({ users: [], counts: {} }));
    const h = (e) => !ref.current?.contains(e.target) && setOpen(false);
    document.addEventListener("mousedown", h);
    return () => document.removeEventListener("mousedown", h);
  }, [open, module]);
  useEffect(() => { if (selectedId && !data) api.get("/users/view-counts", { params: { module: module || "documents" } }).then(({ data }) => setData(data)).catch(() => {}); }, [selectedId]); // eslint-disable-line react-hooks/exhaustive-deps
  if (!isAdmin) return null;
  const selected = selectedId ? (data?.users || []).find((u) => u.id === selectedId) : null;
  const name = (u) => `${u.first_name || ""} ${u.last_name || ""}`.trim();
  return (
    <>
      <span style={{ width: 0.5, height: 18, background: "#2e2e34", margin: "0 4px" }} aria-hidden="true" />
      <span className="relative" ref={ref}>
        <button type="button" role="tab" aria-selected={!!selectedId} onClick={() => setOpen(!open)} className="inline-flex items-center"
          style={{ gap: 6, borderRadius: 6, padding: "6px 13px", fontSize: 11.5, height: 28, background: selectedId ? "#1c1730" : open ? "#1e1e24" : "transparent", border: selectedId ? "0.5px solid #7c5cd0" : "0.5px solid transparent", color: selectedId ? "#c4b3ea" : open ? "#c9c9d1" : "#8b8b93", fontFamily: "Tahoma, sans-serif" }}
          data-testid={`${testid}-user`} data-active={selectedId ? "true" : "false"}>
          {selected ? <><UserAvatar user={selected} size={18} /><span className="truncate" style={{ maxWidth: 140 }}>{name(selected)}</span></> : <><Users size={14} />Utilisateur</>}
          {open ? <ChevronUp size={12} /> : <ChevronDown size={12} />}
        </button>
        {open && (
          <div className="absolute right-0 z-50" style={{ top: "calc(100% + 6px)", width: 236, background: "#18181c", border: "0.5px solid #2e2e34", borderRadius: 8, overflow: "hidden", boxShadow: "0 10px 28px rgba(0,0,0,.5)", fontFamily: "Tahoma, sans-serif" }} data-testid={`${testid}-user-list`}>
            <div style={{ fontSize: 9, color: "#6e6e78", letterSpacing: ".05em", padding: "9px 11px 5px" }}>CHOISIR UN UTILISATEUR</div>
            {!data && <div style={{ padding: "8px 11px", fontSize: 10.5, color: "#6e6e78" }}>Chargement…</div>}
            {(data?.users || []).map((u, i) => (
              <button key={u.id} type="button" onClick={() => { onChange?.(`user:${u.id}`); setOpen(false); }} className="flex items-center w-full text-left hover:bg-white/5"
                style={{ gap: 9, padding: "8px 11px", borderTop: i ? "0.5px solid #222226" : "none", background: u.id === selectedId ? "#1c1730" : "transparent" }} data-testid={`${testid}-user-${u.id}`}>
                <UserAvatar user={u} size={22} />
                <span className="truncate" style={{ flex: 1, fontSize: 11.5, color: "#c9c9d1" }}>{name(u)}</span>
                <span className="tabular-nums" style={{ fontSize: 9.5, color: "#6e6e78" }}>{data.counts?.[u.id] ?? 0}</span>
              </button>
            ))}
          </div>
        )}
      </span>
    </>
  );
}
